import React from 'react';
// import useRequestsTypes from '@ubeya/shared/hooks/generic/useRequestsTypes';

const WhenRendererDetails = () => {
  return <></>;
  // const { mappedRequestsTypes } = useRequestsTypes();
  // const { color } = mappedRequestsTypes?.[typeId]?.kinds?.[data?.jobTypeId] || {};

  // return <span style={{ color }}>Days spent this month: 0</span>;
};

export default WhenRendererDetails;
